import { render, staticRenderFns } from "./CreateTemplateButton.vue?vue&type=template&id=3a437776"
import script from "./CreateTemplateButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateTemplateButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports